import { useState , useEffect } from 'react';
import { Link } from 'react-router-dom';
import './OracleLearningPath.css';
import Modal from '@mui/material/Modal';
import QuickLinks from '../components/QuickLinks';
import learningPaths from '../data/learning_path.json';
import domains from '../data/domain.json';
import specializations from '../data/specialization.json';
import domainWithSpecialization from '../data/domain_with_specialization.json';
import Carousel from 'nuka-carousel';
import { saraswathi_mail, atci_lkm_sap_mail } from '../../utils/mailIds';

const LearningPath = () => {  
  const sortByObjectsName = (arrayOfObjects) => {
    return arrayOfObjects.sort(function (a, b) {
      if ( a.learning_path_name.toLowerCase() < b.learning_path_name.toLowerCase() ){
        return -1;
      }
      if ( a.learning_path_name.toLowerCase() > b.learning_path_name.toLowerCase() ){
        return 1;
      }
      return 0;
    })
  }

  const [filteredLearningPath, setFilteredLearningPath] = useState(sortByObjectsName(learningPaths));
  const [filteredDropdownLP, setFilteredDropdownLP] = useState([]);
  const [filteredSpecializations, setFilteredSpecializations] = useState(specializations);
  const [learningPathDetail, setLearningPathDetail] = useState();
  const [singleLearningPathDetail, setSingleLearningPathDetail] = useState();
  const [learningPathDetailFlag, setLearningPathDetailFlag] = useState(false);
  const [singleLearningPathDetailFlag, setSingleLearningPathDetailFlag] = useState(false);
  const [searchBoxText, setSearchBoxText] = useState('');
  const [selectedLPName, setSelectedLPName] = useState('');
  const [show, setShow] = useState(false);
  const [numberOfSlides, setNumberOfSlides]=useState(0)

const carouselSlides = () => {
if (window.innerWidth <= 767) {
setNumberOfSlides(1)
} else if(window.innerWidth >= 768 && window.innerWidth <= 991){
setNumberOfSlides(2)
}else{
setNumberOfSlides(3)
}
}
useEffect(() => {
carouselSlides()
})
  const handleEnterSearch = (e) => {
      if(e.key === 'Enter') {
          e.preventDefault();
          searchLearningPath();
      }        
  }
  const changeDomain = event => {
    setSearchBoxText('');
    setLearningPathDetailFlag(false);
    setSingleLearningPathDetailFlag(false);
    setSelectedLPName('');
    if (event.target.value === 'all') {
      setFilteredLearningPath(sortByObjectsName(learningPaths));
      setFilteredDropdownLP([]);
      setFilteredSpecializations(specializations);
    } else {
      let filterDomainLPaths = [];
      domains.forEach((obj, index) => {
        if (obj.domain === event.target.value) {
          obj.learning_path_name.forEach(lp_name => {
            filterDomainLPaths.push({ learning_path_name: lp_name });
          });
        }
      });
      setFilteredLearningPath(sortByObjectsName(filterDomainLPaths));
      setFilteredDropdownLP(filterDomainLPaths);

      let filteredSpec = [];
      domainWithSpecialization.forEach(obj => {
        if (obj.domain === event.target.value) {
          obj.specialization.forEach(spec => {
            filteredSpec.push({ specialization: spec });
          });
        }
      });
      setFilteredSpecializations(filteredSpec);
    }
  };

  const changeSpecialization = event => {
    setSearchBoxText('');
    setLearningPathDetailFlag(false);
    setSingleLearningPathDetailFlag(false);
    setSelectedLPName('');
    if (event.target.value === 'all') {
      setFilteredLearningPath(sortByObjectsName(learningPaths));
      setFilteredDropdownLP([]);
    } else {
      let filteredSpecPaths = [];
      specializations.forEach(obj => {
        if (obj.specialization === event.target.value) {
          obj.learning_path_name.forEach(lp_name => {
            filteredSpecPaths.push({ learning_path_name: lp_name });
          });
        }
      });
      setFilteredLearningPath(sortByObjectsName(filteredSpecPaths));
      setFilteredDropdownLP(filteredSpecPaths);
    }
  };

  const searchLearningPath = () => {    
    setLearningPathDetailFlag(false);
    setSingleLearningPathDetailFlag(false);
    setSelectedLPName('');
    var searchResults = [];
    
    if(filteredDropdownLP.length > 0) {
        filteredDropdownLP.forEach(obj => {
          if (obj.learning_path_name.toLowerCase().includes(searchBoxText.toLowerCase())) {
            searchResults.push(obj);
          }
        });
    } else {
        learningPaths.forEach(obj => {
          if (obj.learning_path_name.toLowerCase().includes(searchBoxText.toLowerCase())) {
            searchResults.push(obj);
          }
        });  
    }            
    setFilteredLearningPath(sortByObjectsName(searchResults));
  };

  const clickOnLearningPath = event => {              
      learningPaths.forEach(obj => {
          if (obj.learning_path_name === event.currentTarget.textContent && Object.keys(obj.learning_path_detail).length === 1) {                                  
              setSingleLearningPathDetail(obj.learning_path_detail);
              setLearningPathDetailFlag(false);
              setSingleLearningPathDetailFlag(true);
          }
          else if(obj.learning_path_name === event.currentTarget.textContent && Object.keys(obj.learning_path_detail).length === 3) {
              setLearningPathDetail(obj.learning_path_detail);
              setSingleLearningPathDetailFlag(false);
              setLearningPathDetailFlag(true);      
          }
      })
  };
  const botClickFun = () => {
    document.getElementById('cai-webclient-builtin-button').click();
  };
  const handleOpenModal = () => {
    setShow(true);
  };
  const handleCloseModal = () => {
    setShow(false);
  };
  const allcourseDataforlen = (item) => {
    return (
      <div className="lp-overview-block">
      <Link to={`/Oracle/Course/${item.id}`} target="_blank">
        <span className="lp-overview-block-headng">{item.course_name}</span>
      </Link>
      {/* <span className="lp-course_code">
        <p className="course-code-text">
          Course Code : <span>{item.course_code}</span>
        </p>
      </span> */}
      <div className="cardBottomContent">
        <div className="metroData">
          <img src={process.env.PUBLIC_URL + "/images/SAP/learning_path/mode.png"} alt="" className="lp-metro-switch" />
          <span className="lp-switch-text">{item.mode}</span>
        </div>
        <div className="timeData">
          <img src={process.env.PUBLIC_URL + "/images/SAP/learning_path/time.png"} alt="" className="lp-time" />
          <span className="lp-time-text">{item.hours}h</span>
        </div>
      </div>
    </div>
    )
    }
    const singlecourseDataforlen = (item) => {
      return (
        <div className="lp-overview-block">
      <Link to={`/Oracle/Course/${item.id}`} target="_blank">
        <span className="lp-overview-block-headng">{item.course_name}</span>
      </Link>
      {/* <span className="lp-course_code">
        <p className="course-code-text">
          Course Code : <span>{item.course_code}</span>
        </p>
      </span> */}
      <div className="cardBottomContent">
        <div className="metroData">
          <img src={process.env.PUBLIC_URL + "/images/SAP/learning_path/mode.png"} alt="" className="lp-metro-switch" />
          <span className="lp-switch-text">{item.mode}</span>
        </div>
        <div className="timeData">
          <img src={process.env.PUBLIC_URL + "/images/SAP/learning_path/time.png"} alt="" className="lp-time" />
          <span className="lp-time-text">{item.hours}h</span>
        </div>
      </div>
    </div>
      )
      }
  return (
    <div id="main_container" className="lp_main_container">
      {/* <div className="banner_container">
            <img src="images/SAP/learning_path/banner.png" alt="Sap-Banner" />
        </div> */}
      <div className="oracle-lp-banner">
        <img
          src={process.env.PUBLIC_URL + '/images/Oracle/learning_paths/banner.png'}
          alt="Sap-Banner"
          className="img-responsive"
        />
        <div>
          {/* <h1>Learning Paths</h1>
              <span>A comprehensive guide for SAP learning paths</span> */}
        </div>
      </div>
      <div className="section_container">
        <div className="banner-content">
          <p>
            Welcome to the one-stop-shop of Enterprise Platforms learnings offerings. Search a topic/course name, find the link
            to its learning path, and get one step closer to completing your Enterprise Platforms learning journey.
          </p>
        </div>
        {/* <h2 className="searchHeading">Your comprehensive guide to all E&IT Academy learning paths</h2>
            <p className="section_para">
              Welcome to the one-stop-shop of E&IT Academy’s learnings offerings. Search a topic/course name, find the link to its learning path, and get one step closer to completing your E&IT learning journey.
            </p>             */}
        <br />
        <br />
        <form className="form_container d-flex searchCourses">
          <div className="searchBox1">
            <lable className="lp_lable_container">Domain </lable>
            <select className="selection_container" onChange={e => changeDomain(e)}>
              <option key="all" value="all" selected>
                All
              </option>
              {domains.map(item => {
                return (
                  <option key={item.domain} value={item.domain}>
                    {item.domain}
                  </option>
                );
              })}
            </select>
          </div>
          <div className="searchBox2">
            <lable className="lp_lable_container">Specialization </lable>
            <select className="selection_container" onChange={e => changeSpecialization(e)}>
              <option key="all" value="all" className="option_container" selected>
                All
              </option>
              {filteredSpecializations.map(item => {
                return (
                  <option key={item.specialization} value={item.specialization}>
                    {item.specialization}
                  </option>
                );
              })}
            </select>
          </div>
          <div className="searchBox3">
            <lable className="lp_lable_container">Keyword Search</lable>
            <div className="goButton">
              <input
                type="search"
                className="search_wrapper"
                value={searchBoxText}
                onKeyPress={handleEnterSearch}
                onChange={e => setSearchBoxText(e.target.value)}
              />
              <input className="search_btn" type="button" onClick={searchLearningPath} />
            </div>
          </div>
        </form>
      </div>
      <div className="lp-menu-container">
        <div className="lp-menu-header">Learning Paths</div>        
        <div className="lp-menu-content" style={{maxHeight: Math.ceil(filteredLearningPath.length / 4) * 65}}px>
          {filteredLearningPath.length > 0 &&
            filteredLearningPath.map((item, index) => {
              return (
                <div className='lp-name-btn-container'>
                    <span
                      className={selectedLPName === item.learning_path_name ? 'lp-menu-btn active_lp_path' : 'lp-menu-btn'}
                      onClick={e => {setSelectedLPName(e.currentTarget.innerText);clickOnLearningPath(e);}}
                    >
                      {item.learning_path_name}
                    </span>
                </div>
              );
            })}
            {filteredLearningPath.length === 0 && <span>No Learning Path Found</span>}
        </div>
      </div>
      {learningPathDetailFlag === true && (
        <div className="learning-path">
          <div className="outerWrapper">
            <div className="lp-col1">
              <img src={process.env.PUBLIC_URL + "/images/SAP/learning_path/ver-dotted-line.png"} alt="" className="ver-dotted-line" />
              <img src={process.env.PUBLIC_URL + "/images/SAP/learning_path/locator.png"} alt="" className="locator1" />
              <img src={process.env.PUBLIC_URL + "/images/SAP/learning_path/locator.png"} alt="" className="locator2" />
              <img src={process.env.PUBLIC_URL + "/images/SAP/learning_path/locator.png"} alt="" className="locator3" />
              <img src={process.env.PUBLIC_URL + "/images/SAP/learning_path/hor-dotted-line.png"} alt="" className="hor-dotted-line1" />
              <img src={process.env.PUBLIC_URL + "/images/SAP/learning_path/hor-dotted-line.png"} alt="" className="hor-dotted-line2" />
              <img src={process.env.PUBLIC_URL + "/images/SAP/learning_path/hor-dotted-line.png"} alt="" className="hor-dotted-line3" />
              <span className="lp-col1-overview-text1">Start with Overview</span>
              <span className="lp-col1-overview-text2">Get Deep Knowledge with specialization skills</span>
              <span className="lp-col1-overview-text3">Become Expert</span>
            </div>
            <div className="lp-col2">
            {learningPathDetail.overview.length >= 4 ? (
            <Carousel className="lp-overview" slidesToShow={numberOfSlides} scrollMode="remainder"
            renderCenterLeftControls={({ previousSlide }) => (
              <button className="sm-lp-left-carasol" onClick={previousSlide}>
              &lt;
              </button>
              )}
              renderCenterRightControls={({ nextSlide }) => (
              <button className="sm-lp-right-carasol" onClick={nextSlide}>
              &gt;
              </button>
              )}
              >
              {learningPathDetail.overview.map((item, index) => {
              return (
              allcourseDataforlen(item)
              );
              })}</Carousel>): learningPathDetail.overview.map((item, index) => {
              return (
              allcourseDataforlen(item)
              );
              })} 

{learningPathDetail.deep_knowledge.length >= 4 ? (
            <Carousel className="lp-overview" slidesToShow={numberOfSlides} scrollMode="remainder"
            renderCenterLeftControls={({ previousSlide }) => (
              <button className="sm-lp-left-carasol" onClick={previousSlide}>
              &lt;
              </button>
              )}
              renderCenterRightControls={({ nextSlide }) => (
              <button className="sm-lp-right-carasol" onClick={nextSlide}>
              &gt;
              </button>
              )}
              >
              {learningPathDetail.deep_knowledge.map((item, index) => {
              return (
              allcourseDataforlen(item)
              );
              })}</Carousel>): learningPathDetail.deep_knowledge.map((item, index) => {
              return (
              allcourseDataforlen(item)
              );
              })} 

{learningPathDetail.expert.length >= 4 ? (
            <Carousel className="lp-overview" slidesToShow={numberOfSlides} scrollMode="remainder"
            renderCenterLeftControls={({ previousSlide }) => (
              <button className="sm-lp-left-carasol" onClick={previousSlide}>
              &lt;
              </button>
              )}
              renderCenterRightControls={({ nextSlide }) => (
              <button className="sm-lp-right-carasol" onClick={nextSlide}>
              &gt;
              </button>
              )}
              >
              {learningPathDetail.expert.map((item, index) => {
              return (
              allcourseDataforlen(item)
              );
              })}</Carousel>): learningPathDetail.expert.map((item, index) => {
              return (
              allcourseDataforlen(item)
              );
              })} 
            </div>
          </div>
        </div>
      )}
      {singleLearningPathDetailFlag === true && (
        <div className="learning-path single-learning-path">
          <div className="outerWrapper">
            <div className="lp-col1 single-lp-col1">
              <img src={process.env.PUBLIC_URL + "/images/SAP/learning_path/sm-ver-dotted-line.png"} alt="" className="sm-ver-dotted-line" />
              <img src={process.env.PUBLIC_URL + "/images/SAP/learning_path/locator.png"} alt="" className="sm-locator1" />              
              <img src={process.env.PUBLIC_URL + "/images/SAP/learning_path/hor-dotted-line.png"} alt="" className="sm-hor-dotted-line1" />              
              <span className="sm-lp-col1-overview-text1">Learning Path</span>              
            </div>
            <div className="lp-col2 single-lp-col2">
            {singleLearningPathDetail.courses.length >= 4 ? ( <Carousel className="lp-overview" slidesToShow={numberOfSlides} scrollMode="remainder" 
            renderCenterLeftControls={({ previousSlide }) => (
            <button className="sm-lp-left-carasol" onClick={previousSlide}>
            &lt;
            </button>
            )}
            renderCenterRightControls={({ nextSlide }) => (
            <button className="sm-lp-right-carasol" onClick={nextSlide}>
            &gt;
            </button>
            )}
            >
            {singleLearningPathDetail.courses.map((item, index) => {
            return (singlecourseDataforlen(item));
            })}
            </Carousel>
            ):singleLearningPathDetail.courses.map((item, index) => {
            return (singlecourseDataforlen(item));
            })} 
            </div>
          </div>
        </div>
      )}
      <div className="socialMediaWrap">
        <button className="iconBtn icon6">
          <a href="https://atci.lkm.eitacademy.accenture.com/SAPAcademy/sap-calendar/" target="_blank" rel="noreferrer">
            <img src={process.env.PUBLIC_URL + '/images/SAP/sap_calendar.png'} alt="oracle-icon" />
            <span>SAP Calendar</span>
          </a>
        </button>
        <button className="iconBtn icon5">
          <a href="https://atci.lkm.accenture.com/LKM-eCatalog/SAP-Flipbook" target="_blank" rel="noreferrer">
            <img src={process.env.PUBLIC_URL + '/images/SAP/catalogue_icon.png'} alt="ecatalogs-icon" />
            <span>SAP eCatalog</span>
          </a>
        </button>
        <button className="iconBtn icon4" onClick={botClickFun}>
          <img src={process.env.PUBLIC_URL + '/images/SocialLearning/noun-chatbot-4562760.svg'} alt="oracle-icon" />
          <span>SAP Bot</span>
        </button>
        <button onClick={handleOpenModal} className="iconBtn icon1">
          <img src={process.env.PUBLIC_URL + '/images/SocialLearning/present.svg'} alt="oracle-icon" />
          <span>Request for Training</span>
        </button>
        <Modal
          open={show}
          onClose={handleCloseModal}
          aria-labelledby="simple-modal-title"
          aria-describedby="simple-modal-description"
        >
          <div className="model-container">
            <span className="close_btn_model_reqtraining" onClick={handleCloseModal}>
              X
            </span>
            <h4>Request For Training</h4>
            <div className="model_heading_reqtraining">
              <p className="model_name_reqtraining">
                <a
                  href="https://lkmportal.atci.accenture.com/LMS/Need/RaiseTrainingRequest"
                  target="_blank"
                  rel="noreferrer"
                >
                  Link to raise training request
                </a>
              </p>
              <div className="modal_content_reqtraining">
                For further queries please get in touch with <br />
              </div>
              <p className="model_contact_reqtraining">
                <a href={`mailto:${saraswathi_mail}`} target="_blank" rel="noreferrer">
                  Swaminathan, Saraswathi.
                </a>
              </p>
            </div>
          </div>
        </Modal>
        <button className="iconBtn icon2">
          <a
            href="https://web.yammer.com/main/groups/eyJfdHlwZSI6Ikdyb3VwIiwiaWQiOiIxMDU4MzIwMzAyMDgifQ/all"
            target="_blank"
            rel="noreferrer"
          >
            <img src={process.env.PUBLIC_URL + '/images/SocialLearning/Yammer1.png'} alt="oracle-icon" />
            <span>Connect with Community</span>
          </a>
        </button>
        <button className="iconBtn icon3">
          <a href={`mailto:${atci_lkm_sap_mail}`} target="_blank" rel="noreferrer">
            <img src={process.env.PUBLIC_URL + '/images/SocialLearning/mail.svg'} alt="oracle-icon" />
            <span>Contact Us</span>
          </a>
        </button>
      </div>
      <QuickLinks />
    </div>
  );
};

export default LearningPath;